"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _dotNotation = require("@cookbook/dot-notation");

var _options = require("./options");

var _toArray = _interopRequireDefault(require("./utils/to-array"));

var _is = _interopRequireDefault(require("./utils/is"));

var _typeOf = _interopRequireDefault(require("./utils/type-of"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var suppress = Symbol('map-suppress');

var map = function map(source) {
  var mapperOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!_is.default.object(source)) {
    throw new TypeError("Instance of \"source\" must be an object, but instead got \"".concat((0, _typeOf.default)(source), "\""));
  }

  return function (keys) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var OPTIONS = _objectSpread(_objectSpread(_objectSpread({}, _options.defaultOptions), mapperOptions), options);

    var result = _is.default.array(keys) ? keys.map(function (key) {
      return (0, _dotNotation.pick)(source, key);
    }) : (0, _dotNotation.pick)(source, keys);
    return {
      transform: function transform(callback) {
        result = _is.default.array(keys) ? callback.apply(void 0, _toConsumableArray(result)) : callback(result); // eslint-disable-next-line @typescript-eslint/no-unsafe-return

        return this;
      },

      get value() {
        var omitNullUndefined = OPTIONS.omitNullUndefined,
            omitStrategy = OPTIONS.omitStrategy;

        if (_is.default.nullOrUndefined(result) && omitNullUndefined || omitStrategy && omitStrategy(result)) {
          return suppress;
        }

        return result;
      }

    };
  };
};

map.omitEntries = function (entries) {
  var result = (0, _toArray.default)(entries).map(function (entry) {
    var values = {};
    var keys = Object.keys(entry);

    for (var i = 0; i < keys.length; i += 1) {
      var key = keys[i];

      if (entry[key] !== suppress) {
        values[key] = entry[key];
      }
    }

    return values;
  });
  return _is.default.array(entries) ? result : result[0];
};

map.suppress = suppress;
var _default = map;
exports.default = _default;